var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:({
    color: _vm.color,
  })},[_vm._v(" "+_vm._s(_vm._profitData)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }